<template>
    <l-control position="bottomright">
        <button v-show="editor.mode == 'editing'" @click="toggleEditingLock()">
            <div v-if="this.etude_data[this.propertyAccessorView + 'editLock']">
                <svg width="24" height="26" xmlns="http://www.w3.org/2000/svg" class="feather feather-lock"
                    stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor" fill="none">
                    <g>
                        <title>Layer 1</title>
                        <rect id="svg_1" ry="2" rx="2" height="11" width="18" y="13.09945" x="3" />
                        <path id="svg_2" d="m7,12.65746l0,-4a5,5 0 0 1 10,0l0,4" />
                    </g>
                </svg>
            </div>
            <div v-else>
                <svg width="24" height="26" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
                    <g>
                        <title>Layer 1</title>
                        <rect x="3" y="13.09945" width="18" height="11" rx="2" ry="2" id="svg_1" />
                        <path d="m4.80088,10.89672l0,-4a5,5 0 0 1 10,0l0,4" id="svg_2"
                            transform="rotate(-33, 9.80088, 6.39672)" />
                    </g>
                </svg>
            </div>
        </button>
    </l-control>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	props: {
		propertyAccessorView: {
			required: true
		}
	},
	computed: {
		...mapGetters(["etude_data","editor"])
	},
	methods: {
		toggleEditingLock () {
			this.$store.dispatch("edit_object", {
				obj: this.etude_data,
				field: this.propertyAccessorView + "editLock",
				value: !this.etude_data[this.propertyAccessorView + "editLock"],
			});
			this.$emit("toggleInteraction", this.etude_data[this.propertyAccessorView + "editLock"]);
		},
	}
};

</script>